export default "__VITE_ASSET__M1t8hU3J__"